import styled from 'styled-components';

export const StyledIcon = styled.div.withConfig({
  shouldForwardProp: function (prop: string) {
    // prevent accidental forwarding of isActive to DOM
    return prop !== 'isActive';
  }
})`
  display: flex;
  justify-content: flex-start;
  padding: 0 10px;

  svg {
    circle {
      fill: ${(props: any) => (props.$isActive ? '#006af9' : 'transparent')};
    }
  }
`;
